<template>
  <div 
    ref="emailSignUpModal" 
    class="modal fade modal--email-sign-up-homeowners"
    tabindex="-1"
    :aria-hidden="!isActive"
  > 
    <div 
      v-if="currentProblem"
      class="modal-dialog modal-dialog-centered" 
    >
      <div class="modal-content">
        <h2 class="modal__headline"><span class="visually-hidden">Homeowners:</span></h2>

        <p class="modal__subheadline">Find solutions to your water problems immediately.<br> Get <strong>THE CLEAN WATER PLAYBOOK</strong> today!</p>

        <p class="modal__text">A comprehensive overview of more than 15 common<br> water contaminants &mdash; and how to solve them.</p>

        <form ref="emailSignUpForm" method="post" v-on:submit.prevent="onSubmit">
          <label for="es_email" class="visually-hidden">Enter your email</label>
          <input type="email" name="email" id="es_email" v-model="email" placeholder="Enter your email here" required>

          <button 
            type="submit" 
            v-bind:disabled="isSubmitting"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Download For Free!
          </button> 

          <a v-bind:href="'/problems/' + currentProblem.slug" role="button" class="modal__close">No Thanks</a>
        </form>
      </div> <!-- .modal-content -->
    </div> <!-- .modal-dialog -->
  </div> <!-- .modal -->
</template>

<script>
import axios from 'axios'
import { Modal } from 'bootstrap'
import swal from 'sweetalert'

export default {
  props: {
    currentProblem: Object
  },
  data() {
    return {
      modal: null,
      email: null,
      isActive: false,
      isSubmitting: false
    }
  },
  methods: {
    open() {
      const backdrop = document.createElement('div')
      backdrop.classList.add('modal-backdrop', 'fade', 'show')
      document.querySelector('#app-panel').appendChild(backdrop)

      this.modal = new Modal(this.$refs.emailSignUpModal, {
        backdrop: 'static',
        keyboard: false
      })

      this.modal.show()
      this.isActive = true
    },
    close() {
      const backdrop = document.querySelector('.modal-backdrop')
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop)
      }

      this.modal.hide()
      this.isActive = false
    },
    onSubmit() {
      if (! /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        swal('', 'Please enter a valid email address.', 'error')
        return
      }

      this.isSubmitting = true

      const params = new URLSearchParams()
      params.append('action', 'email_sign_up')
      params.append('email', this.email)

      axios.post(ajaxurl, params)
        .then((response) => {
          this.email = null
          this.close()

          // Download a file?
          if (response.data && response.data.downloadUrl) {
            this.downloadFile(response.data.downloadUrl, response.data.downloadName)

          } else {
            if (this.currentProblem && this.currentProblem.slug) {
              window.location = '/problems/' + this.currentProblem.slug

            } else {
              swal('', 'You have successfully subscribed.', 'success')
            }
          }
        })
        .catch(() => {
          swal('', 'An unknown error occurred.', 'error')
        })
        .then(() => {
          this.isSubmitting = false
        })
    },
    downloadFile(fileDownloadUrl, fileDownloadName) {
      var req = new XMLHttpRequest()
      req.open("GET", fileDownloadUrl, true)
      req.responseType = "blob"
      req.onreadystatechange = () => {
        if (req.readyState === 4 && req.status === 200) {

          // Download file
          var blob = new Blob([req.response])

          var a = document.createElement("a")
          document.body.appendChild(a)
          a.style = "display: none"

          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = fileDownloadName || 'Culligan.pdf'
          a.click()

          setTimeout(() => {
            swal('', 'You have successfully subscribed.', 'success')
          }, 500)
        }
      }
      req.send()
    }
  }
}
</script>
